/**
 * Konsol yazımı tek kapı (#275): yalnız geliştirmede (`npm start`, test) yazar,
 * production build'de sessiz. Panelde doğrudan `console.*` kullanılmaz —
 * `npm run lint:rules` yeni `console.*` satırını yakalar.
 */
const enabled = process.env.NODE_ENV !== "production";

const logger = {
  warn: (...args) => {
    if (enabled) console.warn(...args);
  },
  error: (...args) => {
    if (enabled) console.error(...args);
  },
};

export default logger;
